<template>
  <settings-modal
    class="client-request-assign-modal"
  >
    <template slot="heading">Assign request {{ requestSubject }} to {{ admin.id }} (You)?</template>

    <template>
      <p>After reassigning request you'll be able to chat with client and change request status.</p>
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        id="assign-to-me"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onAssignButtonClick"
      >assign to me</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="closeModal"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ClientRequestApi from '@/services/Api/ClientRequestApi'

  // Events
  import { EVENT_CLIENT_REQUEST_UPDATE } from '@/events/clientRequests'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ClientRequestAssignModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        assignClientRequestApiRequest: new ApiRequest(ClientRequestApi.assign)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      ...mapGetters('admin', ['admin']),
      profileId () {
        return this.modal.data.profileId
      },
      requestSeq () {
        return this.modal.data.requestSeq
      },
      requestSubject () {
        return this.modal.data.requestSubject
      },
      loading () {
        return this.assignClientRequestApiRequest.loading
      },
      error () {
        return this.assignClientRequestApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      ...mapActions('clientRequests', ['loadUnreadClientRequestCount']),
      onAssignButtonClick () {
        this.assignClientRequest(this.admin.id)
          .then(this.loadUnreadClientRequestCount)
          .then(() => {
            this.closeModal()
            this.$eventHub.$emit(EVENT_CLIENT_REQUEST_UPDATE)

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Request has been successfully assign to you.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      assignClientRequest (employeeId) {
        return this.assignClientRequestApiRequest.execute({
          profileId: this.profileId,
          seq: this.requestSeq
        }, employeeId)
      }
    }
  }
</script>
